<template>
  <div class="i-section-title">
    <slot></slot>
  </div>
</template>

<style lang="scss">
.i-section-title {
  @include display-sm;

  font-weight: 600;
  text-align: center;

  .highlight {
    color: $bilbao500;
  }

  .unlock-career-potential {
    color: #f79009;
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;

    @media screen and (max-width: $breakpoint-lg) {
      font-size: 42px;
      line-height: 50px;
      font-weight: 700;
      text-align: center;
    }
  }
}
</style>
